module.exports = __webpack_public_path__ + "static/media/HJ_stamp.c7b3a241.png";